import type { PlanFreshness } from "../../Types/AccountPlan";

/**
 * A freshness date as "Oct 31". Date-only strings ("2026-10-31") are calendar
 * dates, not instants, so they are not shifted by the viewer's timezone.
 */
export const freshnessDate = (value?: string | null): string => {
  if (!value) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const d = m
    ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    : new Date(value);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

/** "Due for a refresh on Oct 31" / "Due for a refresh since Oct 31". */
export const dueLine = (f: PlanFreshness): string =>
  `Due for a refresh ${f.overdue ? "since" : "on"} ${freshnessDate(f.due_at)}`;
